import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { COMPONENTS } from '../../../../routers/constants'
import { BuyPackage } from '../../../buyPackage'
import { Element } from '../../../html/element'
import { TextLink } from '../../../html/TextLink'
import { AllPriceIncludeVATText } from '../../allPriceIncludeVATText'
import { ReportPrice } from '../../reportPrice'
import { factSheetTypes } from '../constants'
import { selectData, selectFactSheetChecked } from '../store/slice'
import { selectUserType } from '../../../../layout/store/slice'
import { USER_TYPE } from '../../../../utils/authorization'

const getTotalPrice = (
  { dataBlocks = [], price },
  factSheetChecked = {},
  userType,
) => {
  let totalPrice = 0
  let numChecked = 0

  dataBlocks.forEach((item) => {
    if (factSheetChecked[item.id]) {
      numChecked++
      totalPrice += item.price || 0
    }
  })

  return {
    totalPrice: [
      USER_TYPE.PREMIUM,
      USER_TYPE.TRIAL,
      USER_TYPE.STANDARD,
    ].includes(userType.userTypeId)
      ? price
      : totalPrice,
    price:
      numChecked === Object.keys(factSheetChecked).length ||
      [USER_TYPE.PREMIUM, USER_TYPE.TRIAL, USER_TYPE.STANDARD].includes(
        userType.userTypeId,
      )
        ? price
        : totalPrice,
  }
}

export const FactSheetFooter = ({ type }) => {
  const location = useLocation()

  const data = useSelector(selectData)
  const factSheetChecked = useSelector(selectFactSheetChecked)
  const userType = useSelector(selectUserType)

  const { price, totalPrice } = getTotalPrice(data, factSheetChecked, userType)

  return (
    <Element elementName="div">
      <Element
        className="px3 py2"
        style={{
          backgroundColor: [
            factSheetTypes.POPUP_LITE,
            factSheetTypes.POPUP_OTHERS,
          ].includes(type)
            ? '#FFFFFF'
            : '#F3FBF3',
        }}
      >
        <ReportPrice
          isOneLine
          data={{
            totalPrice,
            price: price - price * (data.discountPercentage || 0),
          }}
        />

        <div className="dFlex mt1">
          <BuyPackage
            fiinGateReportTypeId={data.fiinGateReportTypeId}
            isTwoLine={false}
            disableCallApi={type === factSheetTypes.PREVIEW}
          />
        </div>

        {[factSheetTypes.POPUP_LITE, factSheetTypes.POPUP_OTHERS].includes(
          type,
        ) && (
          <div className="dFlex justifyContentEnd">
            <AllPriceIncludeVATText />
          </div>
        )}
      </Element>

      {type === factSheetTypes.POPUP_OTHERS && (
        <div style={{ marginTop: 12, fontStyle: 'italic' }}>
          <Translate value="common.order.factSheet.NOTE" className="fw600" />
          &nbsp;
          <TextLink
            id={'common_order_factSheet_note'}
            labelLink="common.order.factSheet.LINK"
            value="common.order.factSheet.FOOTER_NOTE"
            isTextDecoration={false}
            url={
              COMPONENTS.companyAnalysis.components.financial.components
                .financialStatements.route + location.search
            }
          />
        </div>
      )}
    </Element>
  )
}
